module.exports = __webpack_public_path__ + "static/media/Vector.63828f0e.svg";